import {ToolCallStatus} from 'llm/chat-library/progress/ProgressTypes';

const FADED_TOOL_CALL_OPACITY = 0.4;

export function getToolCallVisualOpacity(status: ToolCallStatus): number {
  return status === ToolCallStatus.QUEUED || status === ToolCallStatus.CANCELLED
    ? FADED_TOOL_CALL_OPACITY
    : 1;
}
